// Importar jQuery Validation
import validate from 'jquery-validation';
validate;

const translateProcampo = {
    'pt-BR': {
        nome: 'O campo "Nome" não foi preenchido',
        telefone: {
            required: 'O campo "Telefone" não foi preenchido',
            minlength: 'Digite um "Telefone" válido',
        },
        email: {
            required: 'O campo "Email" não foi preenchido',
            email: 'Digite um "Email" válido',
        },
        estado: 'O campo "Estado" não foi selecionado',
        cidade: 'O campo "Cidade" não foi selecionado',
        perfil: 'O campo "Qual é o seu perfil?" não foi selecionado',
        outro_perfil: 'O campo "Outro perfil" não foi preenchido',
        age: 'Você precisa confirmar que tem 18 anos ou mais',
        data: 'Você precisa confirmar se está de acordo com a coleta de dados',
    },
};

const html = document.querySelector('html');
const language = html.getAttribute('lang') || 'pt-BR';

function isHmlHost() {
    return window.location.hostname.includes('hml.base.digital');
}

// Carregar cidades baseado no estado selecionado
function setupCitySelect() {
    const stateProcampo = $('.procampo-form select[name="estado"]');
    const cidadeProcampo = $('#cidade-procampo');

    if (stateProcampo.length === 0 || cidadeProcampo.length === 0) {
        return;
    }

    stateProcampo.off('change.procampo').on('change.procampo', function () {
        const selectedState = $(this).val();

        if (!selectedState) {
            cidadeProcampo.html('<option value="">Selecione a Cidade</option>');
            return;
        }

        // Desabilitar select de cidade enquanto carrega
        cidadeProcampo.prop('disabled', true);
        cidadeProcampo.html('<option value="">Carregando...</option>');

        $.ajax({
            type: 'GET',
            url: `https://brasilapi.com.br/api/ibge/municipios/v1/${selectedState}`,
            contentType: 'application/json; charset=utf-8',
            async: true,
        })
            .done(function (response) {
                let cidades = '<option value="">Selecione a Cidade</option>';

                $.each(response, function (c, cidade) {
                    const nomeCidade = cidade.nome;
                    cidades +=
                        '<option value="' + nomeCidade + '">' + nomeCidade + '</option>';
                });

                cidadeProcampo.html(cidades);
                cidadeProcampo.prop('disabled', false);
            })
            .fail(function () {
                cidadeProcampo.html('<option value="">Erro ao carregar cidades</option>');
                cidadeProcampo.prop('disabled', false);
            });
    });
}

// Exibir o campo "Outro perfil" apenas quando "Outro" é selecionado
function setupPerfilToggle() {
    const perfilSelect = $('.procampo-form select[name="perfil"]');
    const outroWrapper = $('#outro-perfil-wrapper-procampo');
    const outroInput = $('#outro-perfil-procampo');

    if (perfilSelect.length === 0 || outroWrapper.length === 0) {
        return;
    }

    function toggleOutroPerfil() {
        if (perfilSelect.val() === 'Outro') {
            outroWrapper.removeClass('hidden');
        } else {
            outroWrapper.addClass('hidden');
            outroInput.val('');
        }
    }

    perfilSelect.off('change.procampo-perfil').on('change.procampo-perfil', toggleOutroPerfil);
    toggleOutroPerfil();
}

function setupProcampoForm() {
    // Verificar se jQuery e jQuery Validate estão disponíveis
    if (typeof $ === 'undefined' || typeof $.fn.validate === 'undefined') {
        console.warn('jQuery ou jQuery Validate não estão disponíveis. Tentando novamente...');
        setTimeout(setupProcampoForm, 200);
        return;
    }

    const form = $('.procampo-form');
    
    // Verificar se o formulário existe
    if (form.length === 0) {
        return;
    }

    const btnSubmit = form.find('.btn-submit-procampo');
    const containerErrors = form.find('.errors');
    const containerSuccess = form.find('.success');

    // Máscaras de input (verificar se jQuery Mask está disponível)
    if (typeof $.fn.mask !== 'undefined') {
        form.find("input[name='telefone']").mask('(00) 00000-0000');
    }

    // Validação do formulário
    form.validate({
        onFocusOut: true,
        focusInvalid: false,
        errorClass: 'input-error',
        errorElement: 'span',
        errorLabelContainer: '.procampo-form .errors',
        rules: {
            nome: {
                required: true,
                minlength: 2,
            },
            telefone: {
                required: true,
                minlength: 14, // (00) 00000-0000
            },
            email: {
                required: true,
                email: true,
            },
            estado: 'required',
            cidade: 'required',
            mensagem: {
                maxlength: 5000,
            },
            perfil: 'required',
            outro_perfil: {
                required: function () {
                    return $('.procampo-form select[name="perfil"]').val() === 'Outro';
                },
                maxlength: 255,
            },
            age: 'required',
            data: 'required',
        },
        messages: translateProcampo[language] || translateProcampo['pt-BR'],
        invalidHandler: function () {
            if (!isHmlHost() && typeof reloadCaptcha !== 'undefined') {
                try {
                    reloadCaptcha('procampo_form');
                } catch (error) {
                    console.warn('reCAPTCHA indisponível:', error);
                }
            }
            btnSubmit.removeClass('loading');
            btnSubmit.removeAttr('disabled');
            containerSuccess.empty();
        },
        submitHandler: function (formElement, event) {
            event.preventDefault();
            event.stopPropagation();

            const $form = $(formElement);
            const valid = $form.valid();
            
            if (valid) {
                btnSubmit.prop('disabled', true);
                btnSubmit.addClass('loading');

                const sendForm = function () {
                    $.ajax({
                        type: 'POST',
                        url: $form.attr('action'),
                        data: $form.serialize(),
                        dataType: 'json',
                        headers: {
                            Accept: 'application/json',
                        },
                    })
                        .done(function (response) {
                            containerErrors.empty();
                            containerSuccess.text(
                                response && response.message
                                    ? response.message
                                    : 'Inscrição enviada com sucesso! Entraremos em contato em breve.',
                            );
                            if (response && response.debug) {
                                console.info('Debug Procampo:', response.debug);
                                containerSuccess.append(
                                    '<br><small>Debug: ' +
                                        (response.debug.salesforce_status || 'sem status') +
                                        '</small>',
                                );
                            }

                            $form.trigger('reset');
                            $form.validate().resetForm();
                            $form.find("input[name='telefone']").val('');
                            $form.find('#cidade-procampo').html('<option value="">Selecione a Cidade</option>');

                            btnSubmit.prop('disabled', false);
                            btnSubmit.removeClass('loading');
                        })
                        .fail(function (xhr) {
                            let errorMessage = 'Erro ao enviar inscrição. Tente novamente mais tarde.';

                            if (xhr.responseJSON) {
                                if (xhr.responseJSON.message) {
                                    errorMessage = xhr.responseJSON.message;
                                } else if (xhr.responseJSON.errors) {
                                    const firstErrorKey = Object.keys(xhr.responseJSON.errors)[0];
                                    if (firstErrorKey) {
                                        errorMessage = xhr.responseJSON.errors[firstErrorKey][0];
                                    }
                                }
                            }

                            containerSuccess.empty();
                            containerErrors.html('<span>' + errorMessage + '</span>');
                            btnSubmit.prop('disabled', false);
                            btnSubmit.removeClass('loading');
                        });
                };

                // Verificar se reloadCaptcha existe antes de usar
                if (!isHmlHost() && typeof reloadCaptcha !== 'undefined') {
                    try {
                        reloadCaptcha('procampo_form', 'g-recaptcha-response', function () {
                            sendForm();
                        });
                    } catch (error) {
                        console.warn('reCAPTCHA indisponível:', error);
                        sendForm();
                    }
                } else {
                    sendForm();
                }
            } else {
                btnSubmit.prop('disabled', false);
                btnSubmit.removeClass('loading');
            }
        },
    });
}

function initializeProcampoForm() {
    // Aguardar jQuery estar disponível
    if (typeof $ === 'undefined') {
        setTimeout(initializeProcampoForm, 100);
        return;
    }

    setupCitySelect();
    setupPerfilToggle();
    setupProcampoForm();
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProcampoForm);
} else {
    initializeProcampoForm();
}
